import { useState, useCallback } from 'react';

export const useImageState = (orientation = 'horizontal', printDimensions = null) => {
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [activeSide, setActiveSide] = useState('front');
  const [isSelected, setIsSelected] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const isHorizontal = orientation === 'horizontal';
  const currentImage = activeSide === 'front' ? frontImage : backImage;
  
  const cardPreset = {
    orientation,
    printDimensions,
    isHorizontal,
  };

  const safeArea = {
    top: 20,
    left: 20,
    right: 20,
    bottom: 20,
  };

  const frontStatus = frontImage ? 'complete' : 'empty';
  const backStatus = backImage ? 'complete' : 'empty';
  const currentStatus = activeSide === 'front' ? frontStatus : backStatus;

  const hasAnyImageDesign = !!(frontImage || backImage);
  const hasBothImageDesigns = !!(frontImage && backImage);

  const updateCurrentImage = useCallback((imageData) => {
    if (activeSide === 'front') {
      setFrontImage(imageData);
    } else {
      setBackImage(imageData);
    }
  }, [activeSide]);

  const setImageForSide = useCallback((side, imageData) => {
    if (side === 'front') {
      setFrontImage(imageData);
    } else {
      setBackImage(imageData);
    }
  }, []);

  const switchSide = useCallback((side) => {
    setActiveSide(side);
  }, []);

  const fitToSafeArea = useCallback((image) => image, []);
  const fillSafeArea = useCallback((image) => image, []);
  const fillCanvas = useCallback((image) => image, []);
  const removeImage = useCallback(() => updateCurrentImage(null), [updateCurrentImage]);
  const duplicateImage = useCallback(() => {
    // Duplicate logic
  }, []);

  return {
    frontImage,
    backImage,
    activeSide,
    currentImage,
    isSelected,
    hasUnsavedChanges,
    cardPreset,
    safeArea,
    isHorizontal,
    frontStatus,
    backStatus,
    currentStatus,
    hasAnyDesign: hasAnyImageDesign,
    hasBothDesigns: hasBothImageDesigns,
    setFrontImage,
    setBackImage,
    setIsSelected,
    setHasUnsavedChanges,
    updateCurrentImage,
    setImageForSide,
    switchSide,
    fitToSafeArea,
    fillSafeArea,
    fillCanvas,
    removeImage,
    duplicateImage,
  };
};
